import { defineNuxtPlugin } from "nuxt/app";
import * as Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";
import HighchartsVue from "highcharts-vue";
import AccessibilityModule from "highcharts/modules/accessibility";
import OfflineExporting from "highcharts/modules/offline-exporting";
import { getHighchartsLangConfig } from "~/utils/getDateFnsLocale";

export default defineNuxtPlugin(({ vueApp }) => {
  if (process.client) {
    HighchartsNoData(Highcharts);
    HighchartsMore(Highcharts);
    Exporting(Highcharts);
    ExportData(Highcharts);
    OfflineExporting(Highcharts);
    AccessibilityModule(Highcharts);

    const userLanguage = localStorage.getItem("language");
    const langConfig = getHighchartsLangConfig(userLanguage);

    Highcharts.setOptions({
      lang: langConfig,
    });

    // ✅ Middleware: Patch getCSV to exclude hidden points
    const originalGetCSV = Highcharts.Chart.prototype.getCSV;

    Highcharts.Chart.prototype.getCSV = function (useLocalDecimalPoint) {
      const csv = originalGetCSV.call(this, useLocalDecimalPoint);

      const hiddenPointNames = this.series
        .flatMap((series) =>
          series.points?.filter((p) => p.visible === false).map((p) => p.name),
        )
        .filter(Boolean);

      if (!hiddenPointNames.length) return csv;

      const lines = csv.split("\n");
      const header = lines[0];
      const dataLines = lines.slice(1);

      const filteredLines = dataLines.filter((line) => {
        return !hiddenPointNames.some((name) => line.startsWith(`"${name}",`));
      });

      const filteredHeader = filteredLines.length ? header : "";

      return [filteredHeader, ...filteredLines].join("\n");
    };

    vueApp.use(HighchartsVue);
  }
});
